import * as React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useLocation, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faSlidersH } from '@fortawesome/free-solid-svg-icons'

import './App.scss';
import { Actions } from './actions';
import Footer from './footer';
import SideNav from './side-nav/SideNav';
import MainNav from './main-nav/MainNav';
import FilterNav from './filter-nav/FilterNav';
import View from './view/View';
import { AppProps, AssociationRootState, BeachRootState } from './';
import ScrollToTop from './ScrollToTop';
import { TickerMatch } from './models';
import MatchStream from './view/match-stream/MatchStream';
import BeachView from './beach/BeachView';
import { CachedTickerMatchSeries } from '../../shared/indoor/cache';
import { AssociationTickerState } from './ticker-state/reducer';
import { TickerSettings } from '../../shared/indoor/ticker';
import { BeachTickerMatch } from './beach/model';
import BeachFilterNav from './beach/filter-nav/BeachFilterNav';

const mapStateToProps = (state: AssociationRootState | BeachRootState) => {
  return {
    connection: state.connection,
    settings: state.tickerState.settings,
    error: state.tickerState.error,
    tickerState: state.tickerState,
    matchDetailView: (state as AssociationRootState).matchDetailView?.view
  }
}

type Props = ReturnType<typeof mapStateToProps> & { dispatch: React.Dispatch<Actions>, appProps: AppProps }

const App = (props: Props) => {

  const [leftSideBarVisible, toggleLeftSideBar] = React.useState(false)
  const [rightSideBarVisible, toggleRightSideBar] = React.useState(false)

  const isOverlayVisible = () => {
    return leftSideBarVisible || rightSideBarVisible
  }

  const hideSideBars = () => {
    toggleLeftSideBar(false)
    toggleRightSideBar(false)
  }

  const onToggleSideBarLeft = (collapsed: boolean) => {
    toggleLeftSideBar(!collapsed)
  }

  const onToggleSideBarRight = (collapsed: boolean) => {
    toggleRightSideBar(!collapsed)
  }

  const {
    appProps,
    tickerState,
    settings,
  } = props

  let location = useLocation();

  const id = location.pathname.replace('/', '')
  const ms = tickerState.matchSeries[id]

  if (location.pathname.includes('stream')) {
    const matchId = location.pathname.split('/').splice(-1)[0]
    const [searchParams] = useSearchParams();
    const size = searchParams.get('size')
    const match = tickerState.matchDays.flatMap(m => m.matches).find(m => m.id === matchId) as TickerMatch | BeachTickerMatch
    if (!match) return <h1>Spiel konnte nicht gefunden werden.</h1>

    return (
      <MatchStream match={match} matchState={tickerState.matchStatesByUuid[matchId]} size={size || undefined} />
    )
  }

  return (
    <ScrollToTop>
      <div className="App">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{ms ? ms.name : appProps.headTitle}</title>
        </Helmet>

        <SideNav nav={<MainNav />} title="MENÜ" position="left"
          toggleIcon={<FontAwesomeIcon icon={faBars} />}
          onToggle={onToggleSideBarLeft}
          visible={leftSideBarVisible}
          hidden={rightSideBarVisible} />

        <SideNav nav={appProps.beach ? <BeachFilterNav /> : <FilterNav />} title="FILTER" position="right"
          toggleIcon={<FontAwesomeIcon icon={faSlidersH} rotation={90} />}
          onToggle={onToggleSideBarRight}
          visible={rightSideBarVisible}
          hidden={leftSideBarVisible} />

        <div className={'App-overlay' + (isOverlayVisible() ? ' active' : '')} onClick={hideSideBars} />

        { appProps.beach
          ? <BeachView appProps={appProps}></BeachView>
          : <View matchDetailView={props.matchDetailView} matchSeries={ms as CachedTickerMatchSeries} tickerState={tickerState as AssociationTickerState} settings={settings as TickerSettings} appProps={appProps} />}

        <Footer copyright={appProps.footerText} url={appProps.footerUrl} />
      </div>
    </ScrollToTop>
  );

}

export default connect(mapStateToProps)(App)
